import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/Banner/banner-4.webp";
import culturalCommittee from "../../Images/student-services/cultural.jpeg";
import { Row } from "react-bootstrap";

const body = [
    { name: "Ms. Vimla Sona", remarks: "Chairperson" },
    { name: "Mr. Preetam", remarks: "Faculty member" },
    { name: "Ms. Rekha Sahu", remarks: "Faculty member" },
    { name: "Mr. Pukhraj Yadav", remarks: "Faculty member" },
    { name: "Ms. Lalita Sahu", remarks: "Faculty member" },
    { name: "Mr. Rajendra Kumar Sahu", remarks: "Faculty member" },
    { name: "Ms. Gaytri", remarks: "Student Member (M.Sc)" },
    { name: "Mr. Akash Barai", remarks: "Student Member (BBA LLB)" },
    { name: "Mr. Ved Prakash", remarks: "Student Member (B.Pharma)" }
];

const CulturalCommittee = () => {
    return (
        <>
            <title>Cultural Committee at ISBM University | Student Activities</title>
            <meta
                name="description"
                content="Join ISBM University's Cultural Committee to explore & celebrate diverse traditions, fostering creativity and unity through various cultural events & activities."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Cultural Committee</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Cultural Committee
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-7">
                            <h2 className="modern-title text-blue">Cultural Committee</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                The Cultural Committee at ISBM University plays a vital role in enriching
                                campus life by promoting creativity, talent, and cultural diversity. It serves
                                as a platform for students to showcase their skills in music, dance, drama,
                                literature, and fine arts through various events and festivals held throughout
                                the academic year.
                            </p>
                            <p className="text-muted">
                                The committee encourages active student participation and fosters a sense of community,
                                teamwork, and cultural appreciation. By organizing workshops, competitions, and annual
                                cultural fests, the committee helps students explore their artistic potential and develop
                                leadership and organizational skills. ISBM University believes that cultural engagement
                                is essential for a well-rounded educational experience.
                            </p>
                        </div>
                        <div className="col-md-5">
                            <div className="governing-image-wrapper shadow">
                                <img src={culturalCommittee} alt="Group photo of students and faculty at an ISBM University event" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Cultural Committee</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default CulturalCommittee;
